import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ALL_PROVIDER_TYPES } from "@/contexts/ServiceContext";
import { HotelServiceProviderType } from "@/types/hotelService";
import React from "react";

const ServiceProviderTypeField = ({
  value,
  onChange,
  className,
  error,
  withNullValue = true,
}: {
  error?: string;
  value?: string;
  onChange: (value: string) => void;
  className?: string;
  withNullValue?: boolean;
}) => {
  return (
    <>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className || ""}>
        <SelectValue placeholder="Provider type" />
      </SelectTrigger>
      <SelectContent>
        {withNullValue && (
          <SelectItem value={ALL_PROVIDER_TYPES}>All provider types</SelectItem>
        )}
        {[HotelServiceProviderType.EXTERNAL_SERVICE, HotelServiceProviderType.GUEST_SERVICE].map((type) => (
          <SelectItem key={type} value={type}>{type}</SelectItem>
        ))}
      </SelectContent>
    </Select>
    {error && <p className={"text-sm text-red-500"}>{error}</p>}
    </>
  );
};

export default ServiceProviderTypeField;
